import { OgpApiService } from './ogp-api-service';
import {
  ServiceAgreementCompany,
  serviceAgreementCompanySchema,
} from './service-agreements.schema';
import {
  ServiceAgreementCompanyResponse,
  ServiceAgreementDetailResponse,
  ServiceAgreementFilterPayload,
  ServiceAgreementsResponse,
} from './service-agreements.types';

export class ServiceAgreementsService {
  constructor(private readonly ogpApiService: OgpApiService) {}

  public getServiceAgreementsForCompany = async (relation?: ServiceAgreementFilterPayload) => {
    return await this.ogpApiService.get<ServiceAgreementsResponse>({
      path: 'service-agreements',
      params: {
        isLender: relation?.isLender,
        isBorrower: relation?.isBorrower,
        oppositeParty: relation?.oppositeParty,
      },
    });
  };

  public getServiceAgreementById = async (id: string) => {
    return await this.ogpApiService.get<ServiceAgreementDetailResponse>({
      path: `service-agreements/${id}`,
    });
  };

  public getCompanyByServiceAgreementId = async (
    serviceAgreementId: string
  ): Promise<ServiceAgreementCompany> => {
    const response = await this.ogpApiService.get<ServiceAgreementCompanyResponse>({
      path: `service-agreements/${serviceAgreementId}/company`,
    });

    return serviceAgreementCompanySchema.parse(response);
  };

  public acceptServiceAgreement = async (id: string) => {
    return await this.ogpApiService.update({
      path: `service-agreements/${id}/accept`,
    });
  };

  public rejectServiceAgreement = async (id: string) => {
    return await this.ogpApiService.update({
      path: `service-agreements/${id}/reject`,
    });
  };
}
